import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { MicrosoftOutlookLogo, ShieldCheck, Sparkle } from '@phosphor-icons/react';

const Login = () => {
  const { login } = useAuth();
  const [signingIn, setSigningIn] = React.useState(false);

  const handleLogin = async () => {
    setSigningIn(true);
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
      const detail = error?.response?.data?.detail;
      const msg = detail || error?.message || 'Unable to reach sign-in service. Please try again.';
      toast.error(`Sign-in unavailable: ${msg}`);
      setSigningIn(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 relative" data-testid="login-page">
      {/* Decorative orb */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full opacity-20 pointer-events-none"
           style={{ background: 'radial-gradient(circle, #C82EEB 0%, transparent 70%)', filter: 'blur(60px)' }} />
      <div className="absolute bottom-1/4 left-1/4 w-80 h-80 rounded-full opacity-15 pointer-events-none"
           style={{ background: 'radial-gradient(circle, #7C3AED 0%, transparent 70%)', filter: 'blur(60px)' }} />

      <div className="w-full max-w-md relative z-10">
        {/* Branding */}
        <div className="flex items-center justify-center space-x-3 mb-10">
          <img
            src="/aays-logo.webp"
            alt="Aays"
            className="h-10 w-auto"
            data-testid="login-aays-logo"
          />
          <div className="h-8 w-px bg-white/20" />
          <span className="text-2xl font-semibold tracking-tight text-white">
            CV Vault
          </span>
        </div>

        {/* Login Card */}
        <div className="glass-card p-8 shadow-2xl">
          <div className="text-center mb-8">
            <div className="inline-flex p-3 rounded-lg mb-4" style={{ background: 'rgba(200, 46, 235, 0.15)', border: '1px solid rgba(200, 46, 235, 0.3)' }}>
              <ShieldCheck size={32} weight="duotone" style={{ color: '#C82EEB' }} />
            </div>
            <h1 className="text-3xl font-semibold tracking-tight mb-3 text-white">
              Welcome back
            </h1>
            <p className="text-base leading-relaxed" style={{ color: '#B8B0C8' }}>
              Sign in with your Microsoft account to continue
            </p>
          </div>

          <button
            onClick={handleLogin}
            disabled={signingIn}
            className="btn-primary w-full flex items-center justify-center space-x-3 px-6 py-3.5 rounded-md text-base font-medium disabled:opacity-60 disabled:cursor-not-allowed"
            data-testid="microsoft-login-button"
          >
            <MicrosoftOutlookLogo size={22} weight="fill" />
            <span>{signingIn ? 'Redirecting to Microsoft…' : 'Continue with Microsoft'}</span>
          </button>

          <div className="flex items-center space-x-2 mt-6 text-xs text-center justify-center" style={{ color: '#7C6E92' }}>
            <Sparkle size={12} weight="fill" style={{ color: '#C82EEB' }} />
            <span>Secured by Azure Active Directory</span>
          </div>
        </div>

        <p className="text-center text-xs mt-8 tracking-widest uppercase" style={{ color: '#7C6E92' }}>
          AI-powered candidate management
        </p>
      </div>
    </div>
  );
};

export default Login;
